export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const API_URL_VERSION = API_URL + process.env.REACT_APP_API_VERSION;
export const ENDPOINT_LOGIN = API_URL + process.env.REACT_APP_API_VERSION + 'v2/auth/login'
export const ENDPOINT_PROFILE_PERMISSION = API_URL + process.env.REACT_APP_API_VERSION + 'usuarios/perfil'
export const ENDPOINT_CONFIGURATION = API_URL_VERSION + 'config';
